module.exports = __webpack_public_path__ + "fonts/dFa4ZfeM_74wlPZtksIFaj8K_1SMdFJ6dQ.woff2";